package com.example.mystybag.appCore.model.pages

data class ContactsUIState(
    val email: String = "support@mystybag.com",
    val phoneNumber: String = "+359883318018"
)
